export const handleChangeDataPageAmazingOffers = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_AMAZING_OFFERS', name, value
});